import type { Market } from "../types/market";

/**
 * Precios EXACTOS por mercado (sin cotización ni redondeo).
 * Deben coincidir con los configurados en Impultienda, que es quien cobra.
 * Países no listados usan `defaultMarket` (USD 19.99).
 */
export const defaultMarket: Market = {
  currency: "USD",
  locale: "en-US",
  main: 19.99,
  bonuses: [17, 15, 12, 9],
};

export const markets: Record<string, Market> = {
  US: defaultMarket,
  AR: { currency: "ARS", locale: "es-AR", main: 27990, bonuses: [26490, 23490, 18990, 13990] },
  MX: { currency: "MXN", locale: "es-MX", main: 329.99, bonuses: [309.99, 279.99, 219.99, 169.99] },
  CO: { currency: "COP", locale: "es-CO", main: 56990, bonuses: [53990, 47990, 37990, 28990] },
  CL: { currency: "CLP", locale: "es-CL", main: 17990, bonuses: [16990, 14990, 11990, 8990] },
  PE: { currency: "PEN", locale: "es-PE", main: 61.99, bonuses: [58.99, 51.99, 40.99, 30.99] },
};
